import { EnvironmentSelectorState } from './reducer'
import {
  ValueProps as EnvironmentSelectorProps
} from '@mulesoft/monitoring-center-components/lib/components/Selector/EnvironmentSelector/EnvironmentSelector'

export const ENVIRONMENT_RESOURCE_NAME = 'environment'
export const ENVIRONMENT_PREFIX = 'MONITORING'

export type EnvironmentSelectorProps = EnvironmentSelectorProps

export const transformToEnvironmentSelectorProps =
  (environmentSelector: EnvironmentSelectorState, maxLength: number, testId?: string, disabled?: boolean): EnvironmentSelectorProps => {
    return {
      environments: environmentSelector.resources,
      isLoading: environmentSelector.isFetching,
      selected: environmentSelector.selected,
      maxLength: maxLength,
      disabled: disabled,
      testId: testId
    }
  }
